export default function TextBtn({ item, TextA }: { item: any; TextA: any }) {
    if (!item || item.isLimit) {
        return null;
    }
    const { signInType, today } = item;

    if (signInType === 1) {
        return TextA.btnMsgDone1;
    }
    if (signInType === 2) {
        return TextA.btnMsgDone2;
    }
    if (today === 'before') {
        // 今天[之前]
        return item.reissueSign ? TextA.btnMsgReissueSign : TextA.btnMsgToday;
    } else if (today === 'today' || today === 'after') {
        // 今天或今天之后
        return TextA.btnMsgToday;
    }
    return null;
}
